<template>
    <MainContent title="Crear comunicado">
        <template v-slot:header>
            <h3 class="card-title pb-3">Crear comunicado</h3>
        </template>
        <template v-slot:content>
            <b-row v-if="!loading">
                <b-col cols="12">
                    <FormComunicado :comunicado="comunicado" @terminado="crearComunicado" />
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComunicado from '@/components/backend/comunicados/FormComunicado';

    export default {    
        data() {
            return {
                comunicado: {
                    listo_para_enviar: false,
                    tipo: this.$route.query.tipo
                },
                loading: false,
                conf: {}
            }
        },
        computed: {
            teatro_id() {
                return this.$store.getters.getTeatroId;
            },
            lista_id() {
                return this.$store.getters.getListaId;
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.crearComunicado();
                }
            },
            crearComunicado() {
                this.loading = true;

                this.comunicado.filters = {};
                this.comunicado.teatro_id = this.teatro_id;
                this.comunicado.lista_abonado_id = this.lista_id;
                this.comunicado.evento_id ? this.comunicado.evento_id = this.comunicado.evento_id.id : this.comunicado.evento_id = null;

                if (this.comunicado.tipo === 2) {
                    delete this.comunicado.contenido;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.comunicados.crear'), this.comunicado).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.comunicados.index', query: { tipo: this.comunicado.tipo } });
                }).finally(() => this.loading = false);
            },
        },
        components: {
            MainContent, FormComunicado
        }
    }
</script>
